import { EnumOwnerType, PersonDetailsQuery } from "gql/generated";
import {
  AdminSection,
  DangerZone,
  Listings,
  ScratchPad,
} from "../../components";
import { useLoggedInAs } from "shared/hooks";
import { useStorefrontView } from "apps/storefront/StorefrontViewContext";

type PersonDetailsInfoProps = {
  person: PersonDetailsQuery["personDetails"];
  onDeleted: () => void;
  adminSectionEnabled?: boolean;
};

export const PersonDetailsInfo = ({
  person,
  onDeleted,
  adminSectionEnabled = false,
}: PersonDetailsInfoProps) => {
  const loggedInAs = useLoggedInAs();
  const { storefrontId } = useStorefrontView();
  const isInStorefrontView =
    loggedInAs?.type === EnumOwnerType.Storefront || !!storefrontId;

  return (
    <>
      {/* The scratch pad is a COMMON place for notes that are visible to ALL users who have access to the person */}
      <ScratchPad person={person} />
      {!isInStorefrontView && (
        <Listings
          personId={person?._id ?? ""}
          listings={person?.operators ?? []}
        />
      )}
      {adminSectionEnabled && (
        <AdminSection person={person} onDeleted={onDeleted} />
      )}
      {!adminSectionEnabled && (
        <DangerZone person={person} onDeleted={onDeleted} />
      )}
    </>
  );
};
